<template>
    <div class="mayorGridManagerApplay-content">
        <!-- 进度条信息 -->
        <div class="pop-modal-mask" style="z-index: 1004" v-if="maskShow"></div>
        <div
            class="mayorGridManagerApplay-content__approveProcess"
            v-if="districtApproveType.type"
        >
            <p-alert :type="districtApproveType.type" show-icon>
                <span>{{ districtApproveType.name }}</span>
                <p-poptip placement="bottom-start" width="400">
                    <span
                        @click="getDistrictApproveProcessClick"
                        style="color: #57a3f3; cursor: pointer"
                        >查看审批流程</span
                    >
                    <div slot="content">
                        <div class="approveProcess__title">
                            审批流编码：{{
                                districtApproveProcess.approveId || ''
                            }}
                        </div>
                        <div class="approveProcess__content">
                            <p-steps
                                :current="approveStepResponseList.length"
                                direction="vertical"
                            >
                                <p-step
                                    v-for="(item,
                                    index) in approveStepResponseList"
                                    :key="index"
                                >
                                    <slot>
                                        <p class="approveProcess__name">
                                            {{ item.approveName }}
                                            <span>{{
                                                dateFormat(
                                                    item.operatorTime,
                                                    'YYYY-MM-DD HH:mm:ss'
                                                )
                                            }}</span>
                                        </p>
                                        <p
                                            class="approveProcess__operator"
                                            style="
                                                font-size: 14px;
                                                margin-top: 5px;
                                            "
                                        >
                                            审批人:{{ item.operator }}
                                        </p>
                                    </slot>
                                </p-step>
                            </p-steps>
                        </div>
                    </div>
                </p-poptip>
                <div style="position: absolute; right: 20px; top: 10px">
                    <p-button
                        type="primary"
                        @click="reApply"
                        v-if="pageStatus === this.PAGESTATUS.REAPPLY"
                        >重新申请</p-button
                    >
                    <!-- 1=未签署 2=签署完成, contractSignType不等于2的时候，才漏出-->
                    <p-button
                        type="primary"
                        v-if="
                            districtApproveType.type === 'success' &&
                                contractSignType !== 2
                        "
                        @click="signContract"
                        >签署合同</p-button
                    >
                </div>
            </p-alert>
        </div>

        <!-- 店长信息部分 -->
        <div class="mayorGridManagerApplay-content__storemanager">
            <div class="storemanager_label">店主信息</div>
            <form-create
                ref="formValidate"
                v-model="fApiStoreManager"
                :rule="rulesStoreManager"
                :option="option"
            ></form-create>
        </div>
        <!-- 区域信息详情页面 -->
        <div
            class="mayorGridManagerApplay-content__storemanager"
            v-if="GridManagerDetailShow"
            v-show="!districtApproveShow"
        >
            <div class="storemanager_label">区域信息</div>
            <form-create
                ref="formValidate"
                v-model="fApiDistrictInfo"
                :rule="rulesDistrictInfo"
                :option="option"
            ></form-create>
        </div>
        <!-- 区域信息表单页面 -->
        <div
            class="mayorGridManagerApplay-content__storemanager"
            v-show="districtApproveShow"
            v-if="!GridManagerDetailShow"
        >
            <div class="storemanager_label">区域信息</div>
            <form-create
                ref="formValidate"
                v-model="fApiDistrictInfoForm"
                :rule="rulesDistrictInfoForm"
                :option="option"
            ></form-create>
        </div>
        <!-- 网格经理详情页 -->
        <!-- 详情页添加数据时，一次只能添加一个 -->
        <!-- GridManagerDetailShow用来编辑的时候，先将其摘除，然后在挂在到vue上面，防止数据不重新渲染 -->
        <div
            class="mayorGridManagerApplay-content__mayorGridManager"
            v-if="GridManagerDetailShow"
            v-show="!districtApproveShow"
        >
            <div class="storemanager_label">
                网格经理申请
                <p-button
                    type="function"
                    size="small"
                    @click="addGridManagerDetail"
                    >添加申请人</p-button
                >
                <span>最多可以添加{{ getMaxWgCountNumber }}个网格经理</span>
            </div>
            <div
                v-for="(item, index) in ListDetail"
                :key="index"
                class="mayorGridManagerApplay-content__mayorGridManager__list"
            >
                <x-h-title :title="`申请人信息${index + 1}`"> </x-h-title>
                <div
                    class="mayorGridManagerApplay-content__mayorGridManager__list__tag"
                >
                    <p-tag
                        v-if="
                            wanggeManagerResponses[index].resultStatus ===
                                WANGGEMANAGER_APPROVE_RESULT_STATUS.AUDITING
                        "
                        color="#E4E7FB"
                        borderColor="transparent"
                        text-color="#4B5FE1"
                        >审批中</p-tag
                    >
                    <p-tag
                        v-if="
                            wanggeManagerResponses[index].resultStatus ===
                                WANGGEMANAGER_APPROVE_RESULT_STATUS.SUCCESS
                        "
                        color="#DCF4EA"
                        borderColor="transparent"
                        text-color="#16B671"
                        >审批通过</p-tag
                    >
                    <p-tag
                        v-if="
                            wanggeManagerResponses[index].resultStatus ===
                                WANGGEMANAGER_APPROVE_RESULT_STATUS.FAILURE
                        "
                        color="#FFF3F2"
                        borderColor="transparent"
                        text-color="#FA2C19"
                        >审批驳回</p-tag
                    >
                    <p-poptip placement="bottom-start" width="400">
                        <span
                            @click="
                                getWgApproveProcessClick(
                                    wanggeManagerResponses[index].lastApplyId
                                )
                            "
                            style="color: #57a3f3; cursor: pointer"
                            >查看审批流程</span
                        >
                        <div slot="content">
                            <div class="approveProcess__title">
                                审批流编码：{{
                                    districtApproveProcess.approveId || ''
                                }}
                            </div>
                            <div class="approveProcess__content">
                                <p-steps
                                    :current="approveStepResponseList.length"
                                    direction="vertical"
                                >
                                    <p-step
                                        v-for="(item,
                                        index) in approveStepResponseList"
                                        :key="index"
                                    >
                                        <slot>
                                            <p class="approveProcess__name">
                                                {{ item.approveName }}
                                                <span>{{
                                                    dateFormat(
                                                        item.operatorTime,
                                                        'YYYY-MM-DD HH:mm:ss'
                                                    )
                                                }}</span>
                                            </p>
                                            <p class="approveProcess__operator">
                                                审批人:{{ item.operator }}
                                            </p>
                                        </slot>
                                    </p-step>
                                </p-steps>
                            </div>
                        </div>
                    </p-poptip>
                </div>
                <!-- 如果网格经理的状态或者区长的申请状态不是审批通过的话，就不能进行修改删除的操作 -->
                <div
                    class="mayorGridManagerApplay-content__mayorGridManager__list__button"
                    v-if="
                        (!isApproveingStaus &&
                            districtApproveType.type === 'success') ||
                            (applyFormType === APPLYFORMTYPE.CANCLEAPPLYFORM &&
                                !isApproveingStaus)
                    "
                >
                    <div v-if="modifyShow[index]">
                        <p-button
                            type="primary"
                            size="small"
                            @click="
                                submitModifyGridManagerDetail(
                                    index,
                                    wanggeManagerResponses[index].status
                                )
                            "
                            >提交</p-button
                        >
                        <p-button
                            size="small"
                            @click="cancleModifyGridManager(index)"
                            >取消</p-button
                        >
                    </div>
                    <div v-if="!modifyShow[index]">
                        <p-button
                            size="small"
                            @click="
                                modifyGridManager(
                                    index,
                                    wanggeManagerResponses[index].resultStatus
                                )
                            "
                            >修改</p-button
                        >
                        <p-poptip placement="top-end" v-model="visible[index]">
                            <div slot="content" class="deleteGridManager__box">
                                <div style="font-weight: 800">
                                    <i
                                        class="pop-icon pop-icon-ios-information-circle"
                                        style="color: #2d8cf0"
                                    ></i>
                                    确定删除此网格经理？
                                    <!-- {{ visible[index] }} -->
                                </div>
                                <div>
                                    1、提交后，审批通过方可删除<br />
                                    2、审批过程中，此网格经理不可以操作相关业务
                                </div>
                                <div class="deleteGridManager__footer">
                                    <p-button
                                        @click="$set(visible, index, false)"
                                        size="small"
                                        >取消</p-button
                                    >
                                    <p-button
                                        type="primary"
                                        size="small"
                                        @click="
                                            deleteGridManagerDetail(
                                                wanggeManagerResponses[index]
                                                    .jdPin,
                                                index
                                            )
                                        "
                                        >确定</p-button
                                    >
                                </div>
                            </div>
                            <p-button size="small">删除</p-button>
                        </p-poptip>
                    </div>
                </div>
                <!-- 详情的页面 -->
                <form-create
                    ref="formValidate"
                    v-model="fApiGridManager[index]"
                    :rule="rulesGridManager[index]"
                    :option="option"
                ></form-create>
            </div>
            <!-- 详情中添加单个网格经理页面-->
            <div
                v-show="listDetailFrom"
                class="mayorGridManagerApplay-content__mayorGridManager__list"
            >
                <x-h-title
                    :title="`申请人信息${ListDetail.length + 1}`"
                ></x-h-title>
                <div
                    class="mayorGridManagerApplay-content__mayorGridManager__list__button"
                >
                    <p-button
                        type="primary"
                        size="small"
                        @click="submitGridManagerDetail"
                        >提交</p-button
                    >
                    <p-button size="small" @click="cancleGridManagerDetail"
                        >取消</p-button
                    >
                </div>
                <form-create
                    ref="formValidate"
                    v-model="fApiGridManagerDetailForm"
                    :rule="rulesGridManagerForm"
                    :option="option"
                ></form-create>
            </div>
        </div>
        <!-- 初次填写网格经理表单页面 -->
        <!--  -->
        <!-- {{GridManagerFromShow}} -->
        <div
            class="mayorGridManagerApplay-content__mayorGridManager"
            v-if="GridManagerFromShow"
            v-show="districtApproveShow"
        >
            <div class="storemanager_label">
                网格经理申请
                <p-button type="function" size="small" @click="addGridManager"
                    >添加申请人</p-button
                >
                <span>最多可以添加{{ getMaxWgCountNumber }}个网格经理</span>
            </div>
            <div
                v-for="(item, index) in List"
                :key="index"
                class="mayorGridManagerApplay-content__mayorGridManager__list"
            >
                <x-h-title :title="`申请人信息${index + 1}`"> </x-h-title>
                <div
                    class="mayorGridManagerApplay-content__mayorGridManager__list__button"
                >
                    <p-button size="small" @click="deleteGridManager(index)"
                        >删除</p-button
                    >
                </div>
                <form-create
                    ref="formValidate"
                    v-model="fApiGridManagerFormList[index]"
                    :rule="rulesGridManagerForm"
                    :option="option"
                ></form-create>
            </div>
        </div>
        <div class="mayorGridManagerApplay-content__storemanager">
            <div class="storemanager_label">门店信息</div>
            <form-create
                ref="formValidate"
                v-model="fApiStoreInfo"
                :rule="rulesStoreInfo"
                :option="option"
            ></form-create>
        </div>
        <div class="mayorGridManagerApplay-content__storemanager">
            <div class="storemanager_label">经济实力</div>
            <form-create
                ref="formValidate"
                v-model="fApiEconomicStrength"
                :rule="rulesEconomicStrength"
                :option="option"
            ></form-create>
        </div>
        <div
            class="mayorGridManagerApplay-content__footer"
            v-if="districtApproveShow"
        >
            <p-button type="primary" @click="addGridManagerAll"
                >确认申请</p-button
            >
        </div>
    </div>
</template>

<script>
import {
    FORM_STOREMANAGER,
    FORM_DISTRICTINFO,
    FORM_STOREINFO,
    FORM_ECONOMICSTRENGTH,
    FORM_DISTRICTINFOFORM,
    FORM_GRIDMANAGER,
    FORM_GRIDMANAGERFORM,
    FORM_GRIDMANAGERFORMMODIFY
} from './schema'
import {
    DISTRICT_APPROVE_RESULT_STATUS,
    WANGGEMANAGER_APPROVE_RESULT_STATUS,
    PAGESTATUS,
    APPLYFORMTYPE
} from '@utils/constants'
import { dateFormat } from '@retailfe/retail-utils'
// import ApproveProcess from '../components/approveProcess'
export default {
    name: 'MayorGridManagerApply',
    data() {
        return {
            // 区长的申请状态
            DISTRICT_APPROVE_RESULT_STATUS: DISTRICT_APPROVE_RESULT_STATUS,
            // 网格经理的申请状态
            WANGGEMANAGER_APPROVE_RESULT_STATUS: WANGGEMANAGER_APPROVE_RESULT_STATUS,
            visible: [],
            // 店主信息的详情
            fApiStoreManager: {},
            // i: 0,
            option: {
                form: {
                    labelWidth: 150
                }
            },
            rulesStoreManager: FORM_STOREMANAGER,
            // 区域信息的详情
            fApiDistrictInfo: {},
            rulesDistrictInfo: FORM_DISTRICTINFO,
            // 门店信息
            fApiStoreInfo: {},
            rulesStoreInfo: FORM_STOREINFO,
            // 经济实力
            fApiEconomicStrength: {},
            rulesEconomicStrength: FORM_ECONOMICSTRENGTH,
            // 区域信息的表单页面
            fApiDistrictInfoForm: {},
            rulesDistrictInfoForm: FORM_DISTRICTINFOFORM,
            // 网格经理详情页
            fApiGridManager: {},
            // rulesGridManager: FORM_GRIDMANAGER,
            rulesGridManager: [],
            // 网格经理申请表单页面
            fApiGridManagerForm: {},
            rulesGridManagerForm: FORM_GRIDMANAGERFORM,
            // 提供一个存储空间用来存储表单
            List: ['a'],
            ListDetail: ['1'],
            // 存储表单数据
            fApiGridManagerFormList: [],
            listDetailFrom: false,
            // 网格经理单个的提交数据
            fApiGridManagerDetailForm: {},
            // 第一次批量添加网格经理
            GridManagerFromShow: false,
            // 详情数据的网格经理
            GridManagerDetailShow: false,
            // 网格经理的数据
            wanggeManagerResponses: [],
            districtHeadId: '',
            // 修改按钮的状态
            modifyShow: [],
            // 区长的申请进度
            approveResultStatus: null,
            // 区长的审批单ID
            districtApproveApplyId: '',
            // 是否有存在中的申请
            isApproveingStaus: false,
            // 区长审批流数据
            districtApproveProcess: {},
            // 审批流详情数据
            approveStepResponseList: [],
            getMaxWgCountNumber: 0,
            districtApproveShow: false,
            // 数据有延迟加上一个遮罩
            maskShow: false,
            contractSignType: 1,
            //页面跳转的信息
            pageStatus: 0,
            // 页面状态常量
            PAGESTATUS,
            // 申请单状态，是否是申请单，还是驳回单
            APPLYFORMTYPE,
            applyFormType: 1
        }
    },
    computed: {
        // // 区长是否申请
        // districtApproveShow: function () {
        //     let isShow = false
        //     if (this.approveResultStatus === null) {
        //         isShow = true
        //     }
        //     // alert(isShow)
        //     return isShow
        // },
        // 区长的申请状态
        districtApproveType: function() {
            let type = {}
            if (
                this.approveResultStatus ===
                this.DISTRICT_APPROVE_RESULT_STATUS.AUDITING
            ) {
                type = {
                    type: 'info',
                    name: '资料审核中'
                }
            } else if (
                this.approveResultStatus ===
                this.DISTRICT_APPROVE_RESULT_STATUS.SUCCESS
            ) {
                type = {
                    type: 'success',
                    name: '资料审批通过'
                }
            } else if (
                this.approveResultStatus ===
                this.DISTRICT_APPROVE_RESULT_STATUS.FAILURE
            ) {
                type = {
                    type: 'error',
                    name: '资料审批驳回'
                }
            }
            return type
        }
    },
    // components: {
    //     ApproveProcess,
    // },
    created() {
        this.getBaseStore()
        this.getDistrict()
        this.getMaxWgCount()
    },
    methods: {
        // 时间转化函数
        dateFormat,
        // 批量添加网格经理
        reApply() {
            // 跳转到新的申请数据
            this.$router.push({
                name: 'mayorGridManagerApply'
            })
        },
        signContract() {
            // 跳转到签署合同的链接
            window.location.href =
                '//jdstore.jd.com/v2?_frameActiveMenu=8395&subMenu3=8395&subMenu1=102122&subMenu2=8391'
        },
        addGridManager() {
            if (this.getCurrentWgCount()) {
                return
            }
            this.List.push('a')
        },
        getCurrentWgCount() {
            let flag = false
            if (this.List.length === this.getMaxWgCountNumber) {
                flag = true
            }
            if (this.ListDetail.length === this.getMaxWgCountNumber) {
                flag = true
            }
            if (flag) {
                this.$Message.warning(
                    `最多可以添加${this.getMaxWgCountNumber}个网格经理`
                )
            }
            return flag
        },
        // 单个添加网格经理
        addGridManagerDetail() {
            // 不能超过最大配置数
            if (this.getCurrentWgCount()) {
                return
            }
            // <!-- 1=未签署 2=签署完成, contractSignType不等于2的时候，才漏出-->
            // 如果是取消区长被驳回的话，就不用判断合同信息了，只有是区长申请单的话，才需要判断
            if (
                this.contractSignType !== 2 &&
                this.applyFormType === this.APPLYFORMTYPE.APPLYFORM
            ) {
                this.$Message.warning(
                    `存在有未签署完成的合同，不能添加网格经理，请完成合同签署`
                )
                return
            }
            if (this.isApproveingStaus) {
                this.$Message.warning(
                    '存在有审批中的网格经理，不能添加网格经理'
                )
                return
            }
            this.listDetailFrom = true
            this.fApiGridManagerDetailForm.resetFields()
            //  this.ListDetail.push('a')
        },
        // 取消单个添加的网格经理
        cancleGridManagerDetail() {
            this.listDetailFrom = false
        },
        // 提交单个添加的网格经理的操作方法
        submitGridManagerDetail() {
            let flag = false
            console.log('--提交单个添加的网格经理start--')
            // console.log(this.fApiGridManagerDetailForm)
            this.fApiGridManagerDetailForm.validate(valid => {
                console.log(valid)
                if (!valid) {
                    flag = true
                    return
                }
            })
            const params = {
                ...this.fApiGridManagerDetailForm.form,
                districtHeadId: this.districtHeadId
            }
            console.log(params)
            if (!flag) {
                this.submitWanggeManager(params)
            }
            console.log('--提交单个添加的网格经理end--')
        },
        // 修改网格经理

        // 提交批量添加的网格经理，以及区长信息的内容
        addGridManagerAll() {
            // console.log(this.fApiGridManagerFormList)
            let params = {}
            this.fApiDistrictInfoForm.validate(valid => {
                console.log(valid)
                if (!valid) {
                    return
                }
                let storeExtParam = this.fApiDistrictInfoForm.form
                let {
                    regionTownCount,
                    regionStoreCount,
                    countyStoreCount,
                    powerTownCount,
                    blankPowerStoreCount,
                    powerStoreCount,
                    thisYearEstimatedSaleMoney
                } = storeExtParam
                // console.log('1',storeExtParam)
                // 需要转化成数字类型的
                params.storeExtParam = {
                    regionTownCount: parseFloat(regionTownCount),
                    regionStoreCount: parseFloat(regionStoreCount),
                    countyStoreCount: parseFloat(countyStoreCount),
                    powerTownCount: parseFloat(powerTownCount),
                    blankPowerStoreCount: parseFloat(blankPowerStoreCount),
                    powerStoreCount: parseFloat(powerStoreCount),
                    thisYearEstimatedSaleMoney
                }
            })
            let form = this.fApiGridManagerFormList.map(item => {
                item.validate(valid => {
                    console.log(valid)
                    if (!valid) return
                })
                // console.log(item)
                let form = item.form
                return form
            })
            params.wanggeManagerParams = form
            console.log('批量的params接口请求', params)
            this.submitDistrict(params)
        },
        deleteGridManager(index) {
            if (this.List.length === 1) {
                console.log('最少保留一个')
                return
            }
            this.List.splice(index, 1)
            this.fApiGridManagerFormList.splice(index, 1)
        },
        // 删除网格经理
        deleteGridManagerDetail(jdPin, index) {
            if (this.ListDetail.length === 1) {
                this.$Message.warning(`最少要保留一个网格经理`)
                return
            }
            // TODO最少要保留一个网格经理
            console.log('删除的网格经理')
            console.log(jdPin, index)
            const params = {
                jdPin: jdPin
            }
            this.deleteWanggeManagerApply(params)
            this.visible[index] = false
        },
        // 编辑网格经理
        // index枚举值。type如果是审批通过的修改，只允许修改电话跟联系地址，如果是驳回的状态，可以修改所有的信息
        modifyGridManager(index, type) {
            console.log(type)
            // this.fApiGridManager[index].refresh(true)
            this.GridManagerDetailShow = false
            // 先注释掉
            // if (type === WANGGEMANAGER_APPROVE_RESULT_STATUS.FAILURE) {
            //     this.rulesGridManager[index] = FORM_GRIDMANAGERFORM
            // } else {
            //     this.rulesGridManager[index] = FORM_GRIDMANAGERFORMMODIFY
            // }
            this.rulesGridManager[index] = FORM_GRIDMANAGERFORMMODIFY
            this.wanggeManagerResponses.map((ele, index) => {
                // this.modifyShow[index] = false
                this.$nextTick(() => {
                    // 需要先重置数据
                    this.fApiGridManager[index].resetFields()
                    this.fApiGridManager[index].setValue(ele)
                })
            })
            this.GridManagerDetailShow = true
            this.modifyShow[index] = true
        },
        submitModifyGridManagerDetail(index, status) {
            // this.fApiGridManager[index].
            let flag = false
            this.fApiGridManager[index].validate(valid => {
                console.log(valid)
                if (!valid) {
                    flag = true
                }
            })
            const params = {
                ...this.fApiGridManager[index].form,
                districtHeadId: this.districtHeadId
            }
            console.log('编辑数据')
            console.log(params)
            if (!flag) {
                // status ===0 》〉可以进行submit ，0也有可能是审核中，操作按钮都不会看见
                // status ===1  可以进行modify 、delete ，status ===2删除了
                // status ===2  网格经理被删除了
                if (status === 0) {
                    this.submitWanggeManager(params)
                }
                if (status === 1) {
                    this.modifyWanggeManagerApply(params)
                }
                this.maskShow = true
                setTimeout(() => {
                    this.maskShow = false
                    this.getDistrict()
                }, 2000)
            }
            // 需要恢复成非表单模式
            this.cancleModifyGridManager()
        },
        cancleModifyGridManager(index) {
            this.GridManagerDetailShow = false
            this.wanggeManagerResponses.map((ele, index) => {
                // this.modifyShow[index] = false
                this.rulesGridManager[index] = FORM_GRIDMANAGER
                this.$nextTick(() => {
                    // 先重置表单数据
                    this.fApiGridManager[index].resetFields()
                    this.fApiGridManager[index].setValue(ele)
                })
            })
            this.modifyShow[index] = false
            this.GridManagerDetailShow = true
        },
        // 获取区长信息
        async getBaseStore() {
            try {
                const res = await this.$apiServe.mayorGridManagerApi.getBaseStore()
                // this.bankAccountType = res
                let val = res || {}
                let {
                    // 出生日期
                    birthday,
                    whetherJingdong,
                    // 内审时间
                    approveSuccessTime,
                    //店外照片
                    outSidePics,
                    //门店位置截图
                    locationScreenshot,
                    // 户外照片
                    shopFrontPic,
                    // 店内照片
                    storeFullViewPics
                } = val
                //组织店内照片数据
                storeFullViewPics = storeFullViewPics || []
                let storeFullViewPicsArray = storeFullViewPics.map(item => ({
                    url: item
                }))
                let valString = this.null2str(val)
                let setVal = {
                    ...valString,
                    birthday: birthday
                        ? dateFormat(birthday, 'YYYY-MM-DD')
                        : '--',
                    approveSuccessTime: approveSuccessTime
                        ? dateFormat(approveSuccessTime, 'YYYY-MM-DD HH:mm:ss')
                        : '--',
                    outSidePics: outSidePics ? outSidePics[0] : '',
                    whetherJingdong: whetherJingdong === true ? '是' : '否',
                    storeFullViewPics: storeFullViewPicsArray,
                    locationScreenshot: locationScreenshot
                        ? locationScreenshot
                        : '',
                    shopFrontPic: shopFrontPic ? shopFrontPic : ''
                }
                console.log(setVal)
                // 填写区长信息表单
                this.$nextTick(() => {
                    this.fApiStoreManager.setValue(setVal)
                    this.fApiStoreInfo.setValue(setVal)
                    this.fApiEconomicStrength.setValue(setVal)
                })
            } catch (err) {
                console.log(err)
            }
        },
        // 提交区长信息
        async submitDistrict(params) {
            try {
                const res = await this.$apiServe.mayorGridManagerApi.submitDistrict(
                    params
                )
                console.log(res)
                this.$Message.success(`添加区长信息成功`)
                // 需要重新刷新数据获取其状态
                this.maskShow = true
                setTimeout(() => {
                    this.maskShow = false
                    this.getDistrict()
                }, 2000)
                // this.bankAccountType = res
            } catch (err) {
                console.log(err)
            }
        },
        // 获取区长信息
        async getDistrict() {
            // this.maskShow = false
            try {
                const res = await this.$apiServe.mayorGridManagerApi.getDistrict()
                // this.bankAccountType = res
                let val = res || {}
                let {
                    storeExtResponse = {},
                    // storeExtResponse
                    wanggeManagerResponses = [],
                    districtHeadId = '',
                    approveResultStatus,
                    lastApplyId,
                    // 合同签署状态
                    contractSignType,
                    //页面状态
                    pageStatus,
                    // 申请单状态
                    applyFormType
                } = val
                this.wanggeManagerResponses = wanggeManagerResponses
                // 储存区长id
                this.districtHeadId = districtHeadId
                // 区长的进度
                this.approveResultStatus = approveResultStatus
                // 这个可以注释掉，因为页面拆分了两个
                if (this.approveResultStatus === null) {
                    this.districtApproveShow = true
                }
                this.districtApproveApplyId = lastApplyId
                // contractSignType合同签署状态
                this.contractSignType = contractSignType
                // 页面状态
                this.pageStatus = pageStatus
                this.applyFormType = applyFormType
                // TODO
                // 驳回后需要展示
                this.GridManagerFromShow = true
                this.GridManagerDetailShow = true
                // 门店信息数据
                // 如果被驳回后，需要显示
                if (wanggeManagerResponses.length > 1) {
                    this.List.length = wanggeManagerResponses.length
                }
                this.ListDetail.length = wanggeManagerResponses.length
                // 循环一个详情表单
                wanggeManagerResponses.map(() => {
                    this.rulesGridManager.push(FORM_GRIDMANAGER)
                })
                // console.log('storeExtResponse', storeExtResponse)
                // 回显区域信息
                this.$nextTick(() => {
                    if (storeExtResponse) {
                        this.fApiDistrictInfo.setValue(storeExtResponse)
                    }
                })
                // 回显区域表单信息，用来重新编辑
                this.$nextTick(() => {
                    if (storeExtResponse) {
                        this.fApiDistrictInfoForm.setValue(storeExtResponse)
                    }
                })
                // 回显区长申请时候的网格经理信息
                this.$nextTick(() => {
                    wanggeManagerResponses.map((ele, index) => {
                        this.fApiGridManagerFormList[index].setValue(ele)
                    })
                    // console.log(this.fApiGridManagerFormList)
                })
                // 回显详情数据
                this.$nextTick(() => {
                    wanggeManagerResponses.map((ele, index) => {
                        // 如果有审批中的状态的话，不能进行添加操作
                        if (
                            ele.resultStatus ===
                            WANGGEMANAGER_APPROVE_RESULT_STATUS.AUDITING
                        ) {
                            // alert()
                            this.isApproveingStaus = true
                        }
                        this.fApiGridManager[index].setValue(ele)
                    })
                })
            } catch (err) {
                console.log(err)
            }
        },
        // 提交网格经理信息
        async submitWanggeManager(params) {
            try {
                const res = await this.$apiServe.mayorGridManagerApi.submitWanggeManager(
                    params
                )
                console.log(res)
                this.$Message.success(`网格经理操作成功`)
                // 添加完成之后需要关闭单个的页面
                this.listDetailFrom = false
                this.maskShow = true
                setTimeout(() => {
                    this.maskShow = false
                    this.getDistrict()
                }, 2000)
            } catch (err) {
                this.maskShow = false
                console.log(err)
            }
        },
        // 修改网格经理信息
        async modifyWanggeManagerApply(params) {
            try {
                const res = await this.$apiServe.mayorGridManagerApi.modifyWanggeManagerApply(
                    params
                )
                console.log(res)
                this.$Message.success(`网格经理操作成功`)
                // 需要重新刷新数据
                this.maskShow = true
                setTimeout(() => {
                    this.maskShow = false
                    this.getDistrict()
                }, 2000)
            } catch (err) {
                this.maskShow = false
                console.log(err)
            }
        },
        // 删除网格经理
        async deleteWanggeManagerApply(params) {
            try {
                const res = await this.$apiServe.mayorGridManagerApi.deleteWanggeManagerApply(
                    params
                )
                console.log(res)
                this.$Message.success(`删除网格经理成功`)
                // 需要重新刷新数据
                this.getDistrict()
            } catch (err) {
                console.log(err)
            }
        },
        // 点击区长审批流进度时候的
        getDistrictApproveProcessClick() {
            this.districtApproveProcess = {}
            this.approveStepResponseList = []
            // alert()
            const params = {
                applyId: this.districtApproveApplyId
            }
            this.getDistrictApproveProcess(params)
        },
        // 点击网格经理的数据
        getWgApproveProcessClick(id) {
            this.districtApproveProcess = {}
            this.approveStepResponseList = []
            const params = {
                applyId: id
            }
            this.getWgManagerApproveProcess(params)
        },
        // 获取区长的审批流数据
        async getDistrictApproveProcess(params) {
            try {
                const res = await this.$apiServe.mayorGridManagerApi.getDistrictApproveProcess(
                    params
                )
                this.districtApproveProcess = res || {}
                const { approveDetailResponse } = res || {}
                this.approveStepResponseList =
                    approveDetailResponse.approveStepResponseList || []
                console.log(res)
            } catch (err) {
                console.log(err)
                // alert()
            }
        },
        // 获取网格经理的审批流数据
        async getWgManagerApproveProcess(params) {
            try {
                const res = await this.$apiServe.mayorGridManagerApi.getWgManagerApproveProcess(
                    params
                )
                this.districtApproveProcess = res || {}
                const { approveDetailResponse } = res || {}
                this.approveStepResponseList =
                    approveDetailResponse.approveStepResponseList || []
                console.log(res)
            } catch (err) {
                console.log(err)
                // alert()
            }
        },
        // 获取最大网格经理数据
        async getMaxWgCount() {
            try {
                const res = await this.$apiServe.mayorGridManagerApi.getMaxWgCount()
                console.log(res)
                this.getMaxWgCountNumber = res
            } catch (err) {
                console.log(err)
                // alert()
            }
        },

        //用来将null数据返回一下返回成---
        null2str(data) {
            for (let x in data) {
                if (data[x] === null || data[x] === '') {
                    // 如果是null 把直接内容转为 ''
                    data[x] = '--'
                } else {
                    if (Array.isArray(data[x])) {
                        // 是数组遍历数组 递归继续处理
                        data[x] = data[x].map(z => {
                            return this.null2str(z)
                        })
                    }
                    if (typeof data[x] === 'object') {
                        // 是json 递归继续处理
                        data[x] = this.null2str(data[x])
                    }
                }
            }
            return data
        }
    }
    // mounted() {
    //     EventBus.$on('aMsg', (msg) => {
    //         console.log(msg)
    //     })
    // },
}
</script>

<style lang="scss" scoped>
.pop-modal-mask {
    background-color: rgba(55, 55, 55, 0);
}
.mayorGridManagerApplay-content {
    position: relative;
    &__approveProcess {
        margin-top: 10px;
        font-size: 16px;
        font-weight: 800;
        /deep/.pop-alert {
            padding-top: 15px;
            padding-bottom: 18px;
        }
        /deep/.pop-alert-icon {
            font-size: 25px;
        }
    }
    &__storemanager,
    &__mayorGridManager {
        margin-top: 10px;
        padding: 16px 16px 0 16px;
        background: #fff;
    }
    &__mayorGridManager {
        .storemanager_label {
            span {
                color: #7c8394;
                margin-left: 10px;
                font-size: 14px;
            }
        }
        &__list {
            position: relative;
            &__tag {
                position: absolute;
                top: -5px;
                left: 130px;
            }
            &__button {
                position: absolute;
                top: -10px;
                right: 0px;
                button {
                    margin-left: 15px;
                }
                .deleteGridManager__box {
                    position: relative;
                    height: 100px;
                }
                .deleteGridManager__footer {
                    position: absolute;
                    right: 0;
                    bottom: 5px;
                }
            }
        }
    }
    &__footer {
        position: fixed;
        text-align: center;
        width: calc(100% - 40px);
        bottom: 0px;
        padding: 10px;
        background: #fff;
        box-shadow: 0 0 8px 0 rgba(191, 191, 191, 0.5);
    }
}
.storemanager_label {
    font-size: 16px;
}
.approveProcess__title {
    padding: 5px 0;
    font-size: 14px;
    color: #1d1f2b;
    font-weight: 800;
}
.approveProcess__content {
    /deep/.pop-steps {
        font-size: 14px !important;
    }
    max-height: 200px;
    overflow: auto;
}
.approveProcess__name {
    font-size: 14px;
    margin-top: -20px;
    font-weight: 800;
    span {
        font-size: 14px;
        color: #666666;
        font-weight: 400;
    }
}
.approveProcess__operator {
    font-weight: 400;
}
</style>
